import React, { useContext } from 'react';
import CompetitionDetailsModuleProps from './type';
import CompetitionDetails from '../../components/CompetitionDetails';
import CompetitionSchedule from '../../components/CompetitionSchedule';
import Commissaires from '../../components/Commissaires';
import LocalizationContext from '../../contexts/Localizations';
import ResultsAccordion from '../../components/ResultsAccordion';
import './styles.scss';

const CompetitionDetailsModule = ({
  competitionDetails,
  schedule,
  assignments,
  results,
}: CompetitionDetailsModuleProps) => {
  const { translations } = useContext(LocalizationContext);

  return (
    <section className="competition-details-module page-template">
      {competitionDetails && (
        <CompetitionDetails
          {...competitionDetails}
          classLabel={translations.competition.classLabel}
          websiteLabel={translations.competition.websiteLabel}
          emailLabel={translations.competition.emailLabel}
        />
      )}

      {results && (
        <ResultsAccordion {...results} />
      )}

      {Boolean(schedule && schedule.items.length) && (
        <CompetitionSchedule
          {...schedule}
          title={translations.competition.racesLabel}
        />
      )}

      {Boolean(assignments && assignments.length) && (
        <Commissaires
          title={translations.competition.assignmentsLabel}
          subtitle={translations.competition.appointedByLabel}
          items={assignments}
        />
      )}
    </section>
  );
};

export default CompetitionDetailsModule;
